import { memo } from 'react';
import { Redirect, Route as ReactRoute } from 'react-router-dom';

const Route = memo(({ children, rendered = true, ...rest }) => {
  return (
    <ReactRoute
      {...rest}
      render={({ location }) =>
        rendered ? children : <Redirect to={{ pathname: '/' }} />
      }
    />
  );
});

export default Route;
